function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "flame_svg__a",
  d: "M0 0h24.571v39.429H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#002F34",
  fillRule: "nonzero",
  d: "M81.286 115.143c0 3.945-13.687 7.143-30.572 7.143-16.884 0-30.571-3.198-30.571-7.143S33.83 108 50.714 108c16.885 0 30.572 3.198 30.572 7.143"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE48D",
  fillRule: "nonzero",
  d: "M91.494 82.402c.049-.8.074-1.6.076-2.402 0-.317-.124-.632-.34-.946-2.509-21.402-20.189-38.768-20.189-38.768s-6.145 6.172-11.705 15.556C51.969 34.805 36.304 19.43 36.304 19.43S9.526 46.285 9.526 76.57c0 .552.022 1.098.055 1.64a4.739 4.739 0 00-.295 1.637c0 16.724 12.53 33.866 38.738 33.866 18.937 0 35.535-7.758 40.625-19.176a20.504 20.504 0 002.887-10.52c0-.541-.022-1.079-.042-1.616"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  fillRule: "nonzero",
  d: "M36.471 79.232c0-.586.107-1.139.3-1.666 0-19.535 5.677-33.72 11.837-43.366-6.61-10.136-13.05-16.486-13.05-16.486S8.387 45.06 8.387 75.896c0 .561.022 1.117.056 1.67-.192.527-.3 1.08-.3 1.666 0 17.028 12.795 34.482 39.388 34.482 5.33 0 10.101-.61 14.326-1.737-18.588-4.82-25.386-18.922-25.386-32.745m27.672-49.518s9.143-6.523 9.143-14.571c0-8.047-9.143-14.572-9.143-14.572S55 7.096 55 15.143c0 8.048 9.143 14.571 9.143 14.571"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.714 32.571)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "flame_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#flame_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#71674E",
  fillRule: "nonzero",
  d: "M12.286 39.429s12.285-8.826 12.285-19.715C24.571 8.826 12.286 0 12.286 0S0 8.826 0 19.714C0 30.603 12.286 39.43 12.286 39.43",
  mask: "url(#flame_svg__b)"
})));

const SvgFlame = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 92,
  height: 123
}, props), _ref, _ref2);

export default SvgFlame;